import { PaletteMode, Components, Theme } from '@mui/material';
import { themePalette } from '../theme.palette';
import { themeShadows } from '../theme.shadows';
import dimensions from '../dimensions';

export const MuiMenuTheme = (mode: PaletteMode): Components<Theme>['MuiMenu'] => {
  const { componentTokens } = themePalette(mode);
  const shadows = themeShadows(mode);
  const { spacing } = dimensions;

  return {
    styleOverrides: {
      paper: {
        backgroundColor: componentTokens.selectMenuItems.color.item.background.containerBase,
        border: `1px solid ${componentTokens.selectMenuItems.color.item.stroke.container.resting}`,
        borderRadius: spacing(1.5), // 6px
        boxShadow: shadows[23], // 16px blur with appropriate shadow color
        marginTop: spacing(2), // 8px
        overflow: 'hidden',
        outline: 'none',
        // Remove MUI's default Paper overlay effect
        '--Paper-overlay': 'none',
        backgroundImage: 'none',
        // Override the specific MUI Paper overlay pseudo-element
        '&::before': {
          backgroundImage: 'none',
          display: 'none',
        },
      },
      list: {
        padding: 0,
        // Remove default focus outline from the list container
        '&:focus': {
          outline: 'none',
        },
      },
    },
  };
};
